import axios from "axios";
import { api } from "./api_route";

export const searchCases = async (searchValue, userId, orgId) => {
  const response = await axios.get(`${api}/task/search`, {
    params: { searchValue, userId, orgId },
  });
  return response.data.data;
};

export const createTask = async (formData) => {
  const response = await axios.post(`${api}/task/create`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data.tasks;
};

export const getCaseTasks = async (userId , orgID) => {
  const response = await axios.get(`${api}/task/getTasks`, {
    params: { userId, orgID },
  });
  return response.data.data;
};

export const updateTask = async (taskNumber, formData) => {
  const response = await axios.put(`${api}/task/edit/${taskNumber}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data.task;
};

export const deleteTask = async (taskNumber) => {
  const response = await axios.delete(`${api}/task/delete/${taskNumber}`);
  return response.data;
};

export const taskDocumentDownload = async (values) => {
  try {
    const response = await axios.get(
      `${api}/documents/taskDocument/${values.original.documentNewName}`,
      {
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    return [];
  }
};

export const taskDocumentDelete = async ({ TaskDocId, userId }) => {
  try {
    const response = await axios.delete(`${api}/task/deleteDocument`, {
      data: { TaskDocId, userId },
    });
    return response.data;
  } catch (error) {
    console.error("taskDocumentDelete error:", {
      message: error.message,
      response: error.response?.data,
    });
    throw new Error(
      error.response?.data?.message || "Failed to delete document",
    );
  }
};

export const sendTaskEmail = async (taskId, includeAdditional) => {
  try {
    const response = await axios.post(`${api}/task/updateEmail/${taskId}`, {
      includeAdditional,
    });
    return response.data;
  } catch (error) {
    console.error("sendTaskEmail error:", {
      message: error.message,
      response: error.response?.data,
    });
    throw new Error(error.response?.data?.message || "Failed to send email");
  }
};
